import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { b as ButtonType, a as ButtonAppearance, d as defineCustomElement$3 } from './roche-button2.js';
import { S as StringService } from './index2.js';
import './index3.js';
import { T as TranslationService } from './index6.js';
import { d as defineCustomElement$2 } from './roche-icon2.js';

const rocheTeaserWallCss = ":host{display:block;margin-top:4rem}:host .teaser-wall__teasers{display:grid;grid-template-columns:1fr;gap:2rem 0}@media (min-width: 48rem){:host .teaser-wall__teasers{grid-template-columns:1fr 1fr;gap:3rem 24px}}@media (min-width: 64rem){:host .teaser-wall__teasers{grid-template-columns:1fr 1fr 1fr;gap:3.5rem 24px}}@media (min-width: 90rem){:host .teaser-wall__teasers{grid-template-columns:1fr 1fr 1fr;gap:5rem 32px}}:host .teaser-wall__button{width:100%;display:flex;align-items:center;justify-content:center}:host .teaser-wall__button>*{width:100%}@media (min-width: 48rem){:host .teaser-wall__button>*{width:auto}}::slotted(roche-filters){width:100%;margin:0 0 2.5rem}@media (min-width: 64rem){::slotted(roche-filters){margin:0 0 3rem}}@media (min-width: 90rem){::slotted(roche-filters){margin:0 0 3rem}}::slotted(roche-filters[no-filterable-content-found]){display:none}::slotted([slot=teasers]){margin-top:0}@media (min-width: 64rem){::slotted([slot=teasers]){margin-top:0}}";
const RocheTeaserWallStyle0 = rocheTeaserWallCss;

const RocheTeaserWall$1 = /*@__PURE__*/ proxyCustomElement(class RocheTeaserWall extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.buttonClickEvent = createEvent(this, "rocheLoadMore", 7);
        this.canLoadMore = undefined;
        this.isFetching = undefined;
        this.translations = undefined;
    }
    async componentWillLoad() {
        this.translations = {
            showMore: await TranslationService.translate('show more'),
        };
    }
    render() {
        return (h(Host, { key: 'e9ac406df89a26f9225f4e0ba688ebdcc68d7b5e' }, h("slot", { key: '08fa0cd0120a9f0bf885d584a141cae2ba7c647e', name: "slotted-filters" }), h("div", { key: '15496c442e70de407ed04d6e3c7118ff10a4e113', class: "teaser-wall__teasers" }, h("slot", { key: '62e4955effe5ccc2d9555a29979bc8a115a1268c', name: "teasers" })), this.canLoadMore && h("div", { class: "teaser-wall__button" }, h("roche-button", { text: StringService.capitalize(this.translations.showMore), type: ButtonType.BUTTON, appearance: ButtonAppearance.PRIMARY, onRocheButtonClick: this.handleClick.bind(this) }))));
    }
    handleClick() {
        this.buttonClickEvent.emit();
    }
    static get style() { return RocheTeaserWallStyle0; }
}, [1, "roche-teaser-wall", {
        "canLoadMore": [4, "can-load-more"],
        "isFetching": [4, "is-fetching"],
        "translations": [32]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-teaser-wall", "roche-button", "roche-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-teaser-wall":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheTeaserWall$1);
            }
            break;
        case "roche-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "roche-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const RocheTeaserWall = RocheTeaserWall$1;
const defineCustomElement = defineCustomElement$1;

export { RocheTeaserWall, defineCustomElement };

//# sourceMappingURL=roche-teaser-wall.js.map